import React, { useCallback, useMemo, useState } from 'react'
import classNames from 'classnames'
import { CheckboxProps, LimitedCheckboxSelectionProps, SelectionHandler, SelectionOptionList } from './types'

export const LimitedCheckboxSelection = ({
  hasError: hasError_,
  options: options_,
  htmlIdPrefix,
  listName,
  limit,
  selected: selected_,
}: LimitedCheckboxSelectionProps): JSX.Element => {
  const options: SelectionOptionList = useMemo(() => JSON.parse(options_) as SelectionOptionList, [options_])
  const hasError = hasError_ === 'true'

  const [selected, setSelected] = useState(JSON.parse(selected_) as number[])

  const onSelect: SelectionHandler = useCallback((id) => setSelected((old) => [...old, id]), [])

  const onUnselect: SelectionHandler = useCallback((id) => {
    setSelected((old) => old.filter((item) => item !== id))
  }, [])

  return (
    <div className="grid grid-cols-2 desktop:grid-cols-3 text-sm">
      {options.map((option) => (
        <Checkbox
          option={option}
          key={option.id}
          onOptionSelect={onSelect}
          onOptionUnselect={onUnselect}
          defaultChecked={selected.includes(option.id)}
          disabled={selected.length >= limit && !selected.includes(option.id)}
          htmlIdPrefix={htmlIdPrefix}
          listName={listName}
          hasError={hasError}
        />
      ))}
    </div>
  )
}

const Checkbox = ({
  htmlIdPrefix,
  option,
  disabled,
  defaultChecked,
  listName,
  hasError,
  onOptionSelect,
  onOptionUnselect,
}: CheckboxProps): JSX.Element => {
  const htmlId = `${htmlIdPrefix}_${option.id}`
  const onChange: React.ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      const checked = e.target.checked
      checked ? onOptionSelect(option.id) : onOptionUnselect(option.id)
    },
    [option, onOptionUnselect, onOptionSelect]
  )

  return (
    <label className="generic-custom-radio-field" htmlFor={htmlId}>
      <input
        defaultChecked={!hasError && defaultChecked}
        disabled={disabled}
        onChange={onChange}
        className="form-check-input check_boxes required"
        required
        aria-required="true"
        type="checkbox"
        value={option.id}
        name={listName}
        id={htmlId}
      />
      <span className="generic-custom-radio" />
      <div className={classNames('font-normal', hasError && 'text-red-700')}>{option.name}</div>
    </label>
  )
}
